import React from "react";
import type { Season } from "../api/types";
import { fmtDay } from "../utils/seasonText";

interface Props {
  season: Season;
  handle: string;
  joining: boolean;
  error: string | null;
  onJoin: () => void;
  onBack: () => void;
}

/** Step 3: confirm and join. */
const StepConfirm: React.FC<Props> = ({ season, handle, joining, error, onJoin, onBack }) => (
  <div className="gm-step">
    <h2 className="gm-step-title">Join the game as {handle}?</h2>
    <p>
      {fmtDay(season.dayKeyFrom)} to {fmtDay(season.dayKeyTo)}. You can&apos;t leave once
      you&apos;re in.
    </p>
    {error ? (
      <p className="gm-error" role="alert">
        {error}
      </p>
    ) : null}
    <div className="gm-nav">
      <div className="gm-nav__row">
        <button type="button" className="gm-button gm-button--plain" onClick={onBack} disabled={joining}>
          Back
        </button>
        <button type="button" className="gm-button gm-button--lemon" onClick={onJoin} disabled={joining}>
          {joining ? "Joining..." : "Join"}
        </button>
      </div>
    </div>
  </div>
);

export default StepConfirm;
